module.exports = __webpack_public_path__ + "img/favicon.97346e56.svg";